import React, { useState } from "react"
import { Link, useStaticQuery, graphql } from 'gatsby'

export default () => {
    const [isOpen, setIsOpen] = useState(false)

    const data = useStaticQuery(graphql`
        query {
            allMarkdownRemark(
                filter: {frontmatter: {section: {eq: "local"}}},
                sort: {fields: [frontmatter___title], order: ASC}
            ) {
                edges {
                    node {
                        frontmatter {
                            title
                        }
                        fields {
                            slug
                        }
                    }
                }
            }
        }
    `)

    return (
        <div className="layout dark">
            <div className="layout__container">
                <div className="layout__wide copyright center">
                    <p style={{ margin: 0 }}>
                        8A Campbell Rd, Takapuna, Auckland 0622 &nbsp; • &nbsp; <Link to='/terms/'>Terms</Link> &nbsp; • &nbsp; <Link to='/privacy/'>Privacy</Link> &nbsp; • &nbsp;
                        <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'baseline' }}>
                            <button 
                                onClick={() => setIsOpen(!isOpen)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    fontSize: 'inherit',
                                    fontFamily: 'inherit',
                                    outline: 'none',
                                    padding: '0',
                                    opacity: 0.8,
                                    transition: 'opacity 0.3s ease'
                                }}
                                onMouseOver={(e) => e.target.style.opacity = 1}
                                onMouseOut={(e) => e.target.style.opacity = 0.8}
                                onFocus={(e) => e.target.style.opacity = 1}
                                onBlur={(e) => e.target.style.opacity = 0.8}
                            >
                                Popular Links {isOpen ? '▲' : '▼'}
                            </button>
                            
                            <div 
                                style={{
                                    maxHeight: isOpen ? '500px' : '0',
                                    opacity: isOpen ? 1 : 0,
                                    overflow: 'hidden',
                                    transition: 'all 0.4s ease-in-out',
                                }}
                            >
                                <ul style={{ 
                                    listStyle: 'none', 
                                    padding: 0, 
                                    margin: '10px 0 0 0', 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    gap: '10px',
                                    textAlign: 'center'
                                }}>
                                    {data.allMarkdownRemark.edges.map(({ node: page }) => (
                                        <li key={page.fields.slug}>
                                            <Link 
                                                to={page.fields.slug}
                                                style={{ color: '#fff', textDecoration: 'none', fontSize: '14px' }}
                                            >
                                                {page.frontmatter.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    )
}
